import { LinearProgress, Paper, Stack, Typography } from '@mui/material';

import { Icon } from '@/components/atoms/Icon/Icon';

import { ATTACHMENT_BUBBLE_MAX_WIDTH } from './attachmentBubble';

export interface FileAttachmentBubbleProps {
  name: string;
  isSending?: boolean;
  isFailed?: boolean;
}

export const FileAttachmentBubble = ({
  name,
  isSending = false,
  isFailed = false,
}: FileAttachmentBubbleProps) => (
  <Paper
    variant={isFailed ? 'chatBubbleFailed' : 'chatBubbleFilled'}
    sx={{ maxWidth: ATTACHMENT_BUBBLE_MAX_WIDTH, px: 1.5, py: 1.25 }}
  >
    <Stack spacing={1}>
      <Stack direction='row' spacing={1.5} sx={{ alignItems: 'center' }}>
        <Icon icon='file-lines' fontSize={20} />
        <Typography variant='body2' sx={{ minWidth: 0, color: 'inherit' }}>
          {name}
        </Typography>
      </Stack>
      {isSending && (
        <LinearProgress
          aria-label='Uploading'
          sx={{
            bgcolor: 'custom.coral.600',
            '& .MuiLinearProgress-bar': { bgcolor: 'custom.neutral.50' },
          }}
        />
      )}
    </Stack>
  </Paper>
);

FileAttachmentBubble.displayName = 'FileAttachmentBubble';
export default FileAttachmentBubble;
